import { useLayoutEffect } from "react";
import { Outlet } from "react-router-dom";
import { SiteFooter } from "@frontend/components/site/footer";
import { SITE_SECTIONS } from "@frontend/components/site/links";
import { TopNav } from "@frontend/components/top-nav";
import { useViewer } from "@frontend/lib/viewer";

/** Public marketing site — landing, auth, creator pages. */
export function SiteLayout() {
  const { viewer } = useViewer();

  useLayoutEffect(() => {
    document.getElementById("prerender")?.remove();
  }, []);

  return (
    <div className="theme-light mkt relative flex min-h-dvh flex-col bg-[#f7faf8]">
      <div className="relative flex min-h-dvh flex-1 flex-col">
        <TopNav viewer={viewer} links={SITE_SECTIONS} />
        {/* The marketing header floats over the page, so every route needs the
            bar's height as clearance. The hero opts back out with `-mt-nav`. */}
        <div className="mkt-below-nav flex flex-1 flex-col">
          <Outlet />
        </div>
        <SiteFooter />
      </div>
    </div>
  );
}
